import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { UploadSimple } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Compact Excel import button + "modèle" link.
 *
 * Props:
 *  - kind: 'materiaux' | 'articles' | 'depenses' | 'factures'
 *  - label: button text (e.g. "Importer Excel")
 *  - onImported: () => void
 *  - testid: prefix for data-testid attributes
 */
export const ExcelImportButton = ({ kind, label = 'Importer Excel', onImported, testid = '' }) => {
  const handleFile = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    const fd = new FormData(); fd.append('file', f);
    try {
      const r = await axios.post(`${API_URL}/api/imports/${kind}`, fd, { withCredentials: true });
      const { created = 0, updated = 0, errors = [] } = r.data || {};
      toast.success(`${created} créé(s), ${updated} mis à jour${errors.length ? `, ${errors.length} erreur(s)` : ''}`);
      if (errors.length) console.warn('Import errors:', errors);
      onImported && onImported(r.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Erreur import');
    }
    e.target.value = '';
  };

  const downloadTemplate = async () => {
    try {
      const r = await axios.get(`${API_URL}/api/imports/template?kind=${kind}`, { withCredentials: true, responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a'); a.href = url; a.download = `modele_${kind}.xlsx`; a.click(); URL.revokeObjectURL(url);
    } catch {
      toast.error('Erreur téléchargement modèle');
    }
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <label
        data-testid={`${testid}import-btn`}
        className="btn btn-secondary"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
      >
        <UploadSimple size={16} weight="bold" /> {label}
        <input type="file" accept=".xlsx" style={{ display: 'none' }} onChange={handleFile} />
      </label>
      <button
        type="button"
        data-testid={`${testid}template-btn`}
        onClick={downloadTemplate}
        style={{ padding: '6px 10px', border: '1px dashed #6B7280', background: 'transparent', color: '#6B7280', borderRadius: 6, cursor: 'pointer', fontSize: '0.78rem', fontWeight: 500 }}
        title="Télécharger un modèle Excel vide"
      >
        Modèle
      </button>
    </span>
  );
};

export default ExcelImportButton;
